import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Box, Container } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import Paper from '@material-ui/core/Paper';


export default class ComponentToPrint extends React.Component {

    render() {
        const tableData = this.props.data;
        const searchData = this.props.searchData;
        const totalRow = this.props.totalRow;

        return (
            <div>
                <h3><center><u>Greenleaf Customer Summary Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.operationEntity}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <Box display="flex" justifyContent="flex-end" p={2}>
                    <Container style={{ marginTop: '40px' }}>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div style={{ marginRight: '15px' }}>
                                <Card style={{ justifyContent: 'center' }}>
                                    <Paper>
                                        <TableContainer>
                                            <Table aria-label="simple table" style={{ width: '400px' }}>
                                                <TableHead>
                                                    <TableRow style={{ border: '2px solid black' }}>
                                                        <TableCell align="center" rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', padding: '5px' }}>
                                                            Reg No
                                                        </TableCell>
                                                        <TableCell align="center" colSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', padding: '5px' }}>
                                                            Net Quantity (Kg)
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableData.map((item, index) => (
                                                        (item.totalAmount > 0 ?
                                                            <TableRow style={{ border: '2px solid black' }} key={index}>
                                                                <TableCell align="center" style={{ border: '2px solid black', fontWeight: 'bold', backgroundColor: '#c4e6bf' }}>
                                                                    {item.registrationNumber}
                                                                </TableCell>
                                                                <TableCell align="center" style={{ border: '2px solid black', fontWeight: 'bold', backgroundColor: '#c4e6bf' }}>
                                                                    {item.totalAmount == 0 ? parseFloat(item.totalAmount) : parseFloat(item.totalAmount).toFixed(2)}
                                                                </TableCell>
                                                            </TableRow>
                                                            :
                                                            <TableRow style={{ border: '2px solid black' }} key={index}>
                                                                <TableCell align="center" style={{ border: '2px solid black', fontWeight: 'bold' }}>
                                                                    {item.registrationNumber}
                                                                </TableCell>
                                                                <TableCell align="center" style={{ border: '2px solid black', fontWeight: 'bold' }}>
                                                                    {item.totalAmount == 0 ? parseFloat(item.totalAmount) : parseFloat(item.totalAmount).toFixed(2)}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    ))}
                                                    <TableRow style={{ border: '2px solid black' }}>
                                                        <TableCell align="center" style={{ border: '2px solid black', fontWeight: 'bold' }}>
                                                            Total
                                                        </TableCell>
                                                        <TableCell align="center" style={{ border: '2px solid black', fontWeight: 'bold' }}>
                                                            {parseFloat(totalRow).toFixed(2)}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Card>
                            </div>
                        </div>
                    </Container>
                </Box>
            </div>
        );
    }
}